import React, { useMemo } from 'react'
import { Loading as AntDLoading } from 'antd-mobile'
import styled from 'styled-components'

export type Alignment = 'center' | 'left' | 'right'
export interface SkeletonProps<T> {
  value: T | undefined
  render: (value: T) => React.ReactElement
  loadingAlignment?: Alignment
}
const Loading = styled.div.attrs({ children: <AntDLoading /> })<{ alignment: Alignment }>`
  margin-top: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: ${({ alignment }) => {
    switch (alignment) {
      case 'center':
        return 'center'
      case 'left':
        return 'start'
      case 'right':
        return 'flex-end'
      default:
        throw new Error(`unsupported alignment: ${alignment}`)
    }
  }};
  align-items: start;
`
export function Skeleton <T>({ value, render, loadingAlignment = 'center' }: SkeletonProps<T>) {
  return useMemo(() => value === undefined ? <Loading alignment={loadingAlignment} /> : render(value), [render, value])
}
